<template>
  <div class="">

    <template v-if="applicant != null">
      
      <template v-if="applicant.person != null">
        <Person :applicant="applicant"></Person>
      </template>

      <template v-if="applicant.company != null">
        <Company :applicant="applicant"></Company>
      </template>

      <template v-if="applicant.trust != null">
        <Trust :applicant="applicant"></Trust>
      </template>

      <div class="button-line">
        <ApplicationButton />
      </div>

      <br/><br/><br/>
    </template>
  </div>
</template>

<script>

  import Person             from './person/Home'
  import Company            from './company/Home'
  import Trust              from './trust/Home'
  import { EventBus }       from '@/shared/event-bus';
  import ApplicationButton  from '@/shared/components/form/ApplicationButton'

  export default {

    components: {
      Company,
      Trust,
      Person,
      ApplicationButton
    },

    data() {
      return {
        loading   : false,
        applicant : null
      }
    },

    watch: {
      '$route' (to, from) {
        this.prepare()
      }
    },

    created() {
      this.prepare()
    },

    computed : {
      isLastApplicant() {
        return this.applicant.id == this.$store.state[this.$store.state.view + 'Module'].client.applicants[this.$store.state[this.$store.state.view + 'Module'].client.applicants.length -1].id
      },

      nextApplicantId() {
        for(let i=0; i < this.$store.state[this.$store.state.view + 'Module'].client.applicants.length; i++) {
          let currApplicant = this.$store.state[this.$store.state.view + 'Module'].client.applicants[i]

          if(currApplicant.id == this.applicant.id && i+1 < this.$store.state[this.$store.state.view + 'Module'].client.applicants.length) {
            return this.$store.state[this.$store.state.view + 'Module'].client.applicants[i+1].id
          }
        }

        return null
      }
    },

    methods : {
      prepare() {
        this.showLoader("Loading profile...")
        this.getApplicant({
          clientId   : this.$route.params.clientId,
          applicantId: this.$route.params.applicantId
        }, (applicant) => {
          this.hideLoader()
          this.applicant = applicant
        })
      },
    }
  }
</script>